// Angel (Stef mtg 8/20): Similar Articles are up to three student-pasted links, each shown as a
// hyperlinked title. Storage stays the legacy "Nearest Neighbor Papers" pitch key — one markdown
// link per line ("[Title](url)", or "<url>" while untitled) — so every read view that already
// renders the field through RichText gets the hyperlinked titles for free.

export interface SimilarArticle {
  url: string;
  title: string;
}

const MD_LINK = /\[([^\]]*)\]\(([^()\s]+)\)/;
const BARE_URL = /(https?:\/\/\S+|www\.\S+)/i;

/** One article per non-empty line: markdown link, bare URL (± surrounding text), or title-only. */
export function parseSimilarArticles(raw: string): SimilarArticle[] {
  return raw
    .split("\n")
    .map((l) => l.trim())
    .filter(Boolean)
    .map((line) => {
      const md = line.match(MD_LINK);
      if (md) return { title: md[1]!.trim(), url: md[2]! };
      const bare = line.match(BARE_URL);
      if (bare) {
        const url = bare[1]!.replace(/[>),.;\]]+$/, "");
        const title = line
          .replace(bare[1]!, "")
          .replace(/[<>[\]():•|–—-]+/g, " ")
          .replace(/\s+/g, " ")
          .trim();
        return { title, url };
      }
      return { title: line, url: "" };
    });
}

/** Slot 1 is mandatory to advance (Angel, 2026-08-28); 2 and 3 are optional. */
export function similarArticleSlotMeta(index: number): { label: string; required: boolean } {
  return { label: `Similar Article ${index + 1}`, required: index === 0 };
}

export function serializeSimilarArticles(rows: SimilarArticle[]): string {
  return rows
    .map((r) => ({ url: r.url.trim(), title: r.title.trim() }))
    .filter((r) => r.url || r.title)
    .map((r) => (!r.url ? r.title : r.title ? `[${r.title}](${r.url})` : `<${r.url}>`))
    .join("\n");
}
